module.exports = __webpack_public_path__ + "static/img/service-protect.f33ecb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/service-protect.png
// module id = QoMy
// module chunks = 0